var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tdx-scroll-navigation flx"},_vm._l((_vm.items),function(item,ind){return _c('li',{key:ind,staticClass:"tdx-scroll-navigation__item bor--all bor--radius-30 pt-6 pt-10--l pb-6 pb-10--l pl-20 pr-20 txt--pointer",class:{
      'tdx-scroll-navigation__item--active bg--color-10 bor--transp':
        item[_vm.valueField] === _vm.currentValue,
      'bor--transp-02': item[_vm.valueField] !== _vm.currentValue,
    },on:{"click":function($event){return _vm.handleItemClick(ind, item)}}},[_c('span',{staticClass:"tdx-scroll-navigation__text txt--bold txt--14px txt--16px--l txt--height-18px txt--height-20px--l",class:{
        'tdx-scroll-navigation__text--active inline-block txt--color-04':
          item[_vm.valueField] === _vm.currentValue,
        'txt--color-03': item[_vm.valueField] !== _vm.currentValue,
      }},[_vm._t("text",null,null,item)],2)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }